import { Enterprise } from 'src/types/enterprise.type';

export const tagCloseIconStyle = {
  width: '14.75px',
  marginLeft: '8px',
} as React.CSSProperties;

export const convertCompanyToEditFormData = (company: Enterprise) => {
  return {
    id: company.id,
    name: company?.company?.name,
    legalCompanyName: company.legalCompanyName,
    emails: company.emails,
    industryId: company.industryId,
    DUNS: company.DUNS,
    website: company.website,
    registryId: company.registryId,
    companyNumber: company.companyNumber,
    countryId: company.countryId,
    creatorCustomerId: company,
  };
};
